<!--
 * @Author: jikeychang@gmail.com
 * @Date: 2022-04-07 11:14:30
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-04-07 11:14:31
 * @Description: FileDescription
-->
<!--
 * @Author: ningbo.kang
 * @Date: 2021-12-23 16:16:14
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-12-30 14:28:35
 * @Description: 描述 loading组件
-->
<template>
  <div class="app-loading ant-modal-mask"
    v-if="loading">
    <a-spin size="large"
      :spinning="loading"
      :tip="tip" />
  </div>
</template>
<script>
export default {
  name: 'Loading',
  data() {
    return {
      loading: false,
      tip: '',
    };
  },
  methods: {
    show(value = true) {
      this.loading = value;
    },
  },
};
</script>
<style lang="less" scoped>
// 覆盖一切 UI message,modal等组件
.app-loading {
  z-index: 1200;
}
.ant-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 420px;
  height: 100%;
}
</style>
